import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'absolute top-1/2 right-0 z-1 flex -translate-1/2 flex-col gap-4 bg-transparent',
    control:
      'text-icon-main-inversion flex h-12 w-12 cursor-pointer items-center justify-center p-0',
    icon: '[&>path]:fill-white [&>rect]:fill-white'
  }
});
